// project-imports
import {
  CREATE_BUG_BEGIN,
  CREATE_BUG_SUCCESS,
  CREATE_BUG_FAILURE,
} from "../constants/actions";

// State variable initialization
export const initialState = {
  isLoading: false,
  error: null,
  bug: [],
};

const bugReducer = (state = initialState, action) => {
  if (action.type === CREATE_BUG_BEGIN) {
    // Set loading state
    return {
      ...state,
      isLoading: action.payload,
      error: null,
    };
  }

  if (action.type === CREATE_BUG_SUCCESS) {
    // Update state 
    return {
      ...state,
      isLoading: false,
      bug: action.payload,
      error: null,
    };
  }

  if (action.type === CREATE_BUG_FAILURE) {
    // Set error state
    return {
      ...state,
      isLoading: false,
      error: action.payload,
    };
  }
  return state;
};

export default bugReducer;
